import React from 'react';
import './Works.css'
import works1 from '../../../../images/works/1.jpg'
import works2 from '../../../../images/works/2.jpg'
import works3 from '../../../../images/works/3.jpg'
import works4 from '../../../../images/works/4.jpg'
import works5 from '../../../../images/works/5.jpg'
import works6 from '../../../../images/works/6.jpg'
import works7 from '../../../../images/works/7.jpg'
import works8 from '../../../../images/works/8.jpg'

const Works = () => {

  return (
    <div className='container my_latest_works'>
      <h3>Latest Works</h3>
      <p>My latest photo projects</p>
      <div className="my_works">
        <img src={works1} alt="" />
        <img src={works2} alt="" />
        <img src={works3} alt="" />
        <img src={works4} alt="" />
        <img src={works5} alt="" />
        <img src={works6} alt="" />
        <img src={works7} alt="" />
        <img src={works8} alt="" />
      </div>
    </div>
  );
};

export default Works;